import { render, staticRenderFns } from "./leftNav.vue?vue&type=template&id=108afd10&scoped=true&"
import script from "./leftNav.vue?vue&type=script&lang=js&"
export * from "./leftNav.vue?vue&type=script&lang=js&"
import style0 from "./leftNav.vue?vue&type=style&index=0&id=108afd10&prod&lang=scss&scoped=true&"
import style1 from "./leftNav.vue?vue&type=style&index=1&id=108afd10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108afd10",
  null
  
)

export default component.exports